const DEV_CONFIG = {
  URL: {
    BNPL_SERVICE: 'https://bnpl-qa1.test.mintifi.com/api',
    BNPL_UI_SERVICE: 'https://bnpl.test.mintifi.com',
  },
  MIX_PANEL_TOKEN: '769590d69bdc2536295f39801f2a3daf',
  LOTUS_PAY_ENV: 'sandbox',
  API_TIMEOUT: 45,
};

const DEV_CONFIG_2 = {
  URL: {
    BNPL_SERVICE: 'https://bnpl-qa2.test.mintifi.com/api',
    BNPL_UI_SERVICE: 'https://bnpl2.test.mintifi.com',
  },
  MIX_PANEL_TOKEN: '769590d69bdc2536295f39801f2a3daf',
  LOTUS_PAY_ENV: 'sandbox',
  API_TIMEOUT: 45,
};

const DEV_CONFIG_3 = {
  URL: {
    BNPL_SERVICE: 'https://bnpl-qa3.test.mintifi.com/api',
    BNPL_UI_SERVICE: 'https://bnpl3.test.mintifi.com',
  },
  MIX_PANEL_TOKEN: '769590d69bdc2536295f39801f2a3daf',
  LOTUS_PAY_ENV: 'sandbox',
  API_TIMEOUT: 45,
};

const DEV_STAG = {
  URL: {
    BNPL_SERVICE: 'https://bnpl-staging.api.mintifi.com/api',
    BNPL_UI_SERVICE: 'https://bnpl-staging.test.mintifi.com',
  },
  MIX_PANEL_TOKEN: '769590d69bdc2536295f39801f2a3daf',
  LOTUS_PAY_ENV: 'sandbox',
  API_TIMEOUT: 45,
};

const PROD_CONFIG = {
  URL: {
    BNPL_SERVICE: 'https://bnpl.api.mintifi.com/api',
    BNPL_UI_SERVICE: 'https://bnpl.mintifi.com',
  },
  MIX_PANEL_TOKEN: '41a45ae28275ce13994ee90453f880e2',
  LOTUS_PAY_ENV: 'production',
  API_TIMEOUT: 45,
  GTM_ID: 'G-J7D3M5NMBH'
};

function getConfig() {
  if (process.env.REACT_APP_ENV === 'development3') {
    return DEV_CONFIG_3;
  }
  else if (process.env.REACT_APP_ENV === 'development2') {
    return DEV_CONFIG_2;
  }
  else if (process.env.REACT_APP_ENV === 'development') {
    return DEV_CONFIG;
  }
  else if (process.env.REACT_APP_ENV === 'staging') {
    return DEV_STAG;
  }
  else 
    return PROD_CONFIG;
}

export default getConfig();
